// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"69407cbd","235":"1ec6b140","464":"1ec6b140","524":"dd745daa","664":"1ec6b140","710":"1ec6b140","718":"bb0eebbc","894":"1ec6b140","958":"1055e9c7"}[chunkId] + ".css";
};